import { IonIcon, useIonRouter } from "@ionic/react";
import { GroupChannel } from "@sendbird/chat/groupChannel";
import { ChannelList as SbChannelList } from "@wearesweet/sendbird-uikit-react";
import { t } from "i18next";
import { chatbubbleOutline } from "ionicons/icons";
import React from "react";
import { useChannelFilter } from "../../../contexts/ChannelFilterContext";
import { channelStatus, PINNED } from "../../../utils/channelStatus";
import { useViewport } from "../../../utils/useViewport";
import { ChannelListHeader } from "./ChannelListHeader";
import { ChannelPreview } from "./ChannelPreview";

export const ChannelListUI = (props: any) => {
  const router = useIonRouter();
  const { currentFilter } = useChannelFilter();
  const { isMobile } = useViewport();

  return (
    <div className={`sendbird-chat-${isMobile ? 'mobile' : 'desktop' }__channel-list`} key={currentFilter}>
      <SbChannelList
        disableAutoSelect
        renderPlaceHolderEmptyList={() => (
          <div className="sendbird-place-holder">
            <div className="sendbird-place-holder__body">
              <IonIcon icon={chatbubbleOutline} size={"large"} />
              <span
                className="sendbird-place-holder__body__text sendbird-label sendbird-label--body-1 sendbird-label--color-onbackground-2"
                style={{
                  textAlign: "center",
                }}
              >
                {currentFilter ? (
                  currentFilter === "h" ? (
                    t("noHelpdeskConversations")
                  ) : (
                    t("noConversationsMatchedYourFilter")
                  )
                ) : (
                  <>
                    {t("notInAnyChatsYet")}
                    <br />
                    {t("whyNotCreateYourOwn")}
                  </>
                )}
              </span>
            </div>
          </div>
        )}
        renderHeader={ChannelListHeader}
        renderChannelPreview={(props) => {
          const chatPrefix = isMobile ? "mchat" : "chat";
          const channelUrlPrefix = `/${chatPrefix}/channels/${props.channel.url}`;
          return <ChannelPreview isCurrent={router.routeInfo.pathname.startsWith(channelUrlPrefix)} {...props} />;
        }}
        queries={{
          channelListQuery: {
            includeEmpty: true,
            includeFrozen: true,
            customTypeStartsWithFilter: currentFilter,
          },
        }}
        sortChannelList={(channels: GroupChannel[]) => {
          return channels.sort((a: GroupChannel, b: GroupChannel) => {
            if (channelStatus(a) === PINNED) {
              //debug(a.name + " is pinned", a.customType);
              return -1;
            }

            if (channelStatus(b) === PINNED) {
              //debug(b.name + " is pinned", a.customType);
              return 1;
            }

            const aLastMessage = a.lastMessage;
            const bLastMessage = b.lastMessage;

            if (!aLastMessage || !bLastMessage) {
              return 0;
            }

            return bLastMessage.createdAt - aLastMessage.createdAt;
          });
        }}
      />
    </div>
  );
};
